import { Injectable } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, Params, Route, Router, UrlTree } from '@angular/router';

import { Store } from '@ngrx/store';
import { tap, filter, take, switchMap, catchError, map } from 'rxjs/operators';

import * as fromStore from '../store';
import { combineLatest, Observable, of } from 'rxjs';
import { StringUtility } from '@teamfoster/sdk/text-utility';

@Injectable({ providedIn: 'root' })
export class CollectionDetailGuard {
  constructor(private store: Store, private router: Router, private route: ActivatedRoute) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    return this.checkStore(route);
  }

  checkStore(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    return combineLatest([
      this.store.select(fromStore.getSelectedCollection),
      this.store.select(fromStore.getCollectionsLoading),
      this.store.select(fromStore.getCollectionsLoaded),
      this.store.select(fromStore.getCollectionError),
    ]).pipe(
      tap(([collection, loading, loaded, error]) => {
        const routeHandle = route.params['collectionHandle'];

        if (!collection?.filters && !loading) {
          this.store.dispatch(fromStore.LoadCollectionByHandle({ handle: routeHandle }));
        }
      }),
      map(([collection, loading, loaded, error]) => {
        if (collection?.filters && collection.handle !== route.params['collectionHandle']) {
          let url = ['/', 'collections', collection.handle];
          if (route.params['productHandle']) {
            url = [...url, route.params['productHandle']];
          }

          const newUrl = this.router.createUrlTree(url, {
            relativeTo: this.route,
            queryParams: route.queryParams,
          });
          return newUrl;
        }

        return (!!collection?.filters && !loading) || (error && !loading);
      }),
      // map(([collection, loading]) => !!collection?.filters && !loading),
      filter(loaded => loaded),
      take(1)
    );
  }
}
